import { animate } from "motion";

const TRANSITION_DURATION = 0.4;
const TRANSITION_EASING = "ease-in-out";
const DEFAULT_INTERVAL = 3000;

class MessageTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-messages-track]");
    this.messages = [...this.querySelectorAll("[data-message]")];
    this.toggleBtn = this.querySelector("[data-ticker-toggle]");
    this.playIcon = this.toggleBtn?.querySelector(".js-icon-play");
    this.pauseIcon = this.toggleBtn?.querySelector(".js-icon-pause");
    this.activeIndex = 0;
    this.isPlaying = true;
    this.interval = parseInt(this.dataset.interval, 10) || DEFAULT_INTERVAL;

    this.manifestTrigger = this.querySelector("[data-manifest-trigger]");
    this.manifestTrigger?.addEventListener("click", () => {
      try {
        sessionStorage.removeItem("legora_manifest_overlay_seen");
      } catch {
        /* storage unavailable */
        console.error("Session storage unavailable");
      }
      window.location.reload();
    });

    if (this.messages.length <= 1) {
      this.toggleBtn?.setAttribute("hidden", "");
      return;
    }

    this.messageHeight = this.messages[0].offsetHeight;

    this.clone = this.messages[0].cloneNode(true);
    this.clone.removeAttribute("data-message");
    this.clone.setAttribute("inert", "");
    this.track.appendChild(this.clone);

    this._updateInert();
    this.toggleBtn?.addEventListener("click", () => this.toggle());
    this.scheduleNext();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  toggle() {
    this.isPlaying = !this.isPlaying;

    if (this.isPlaying) {
      this.scheduleNext();
    } else {
      clearTimeout(this.timer);
    }

    this.playIcon?.classList.toggle("hidden", this.isPlaying);
    this.pauseIcon?.classList.toggle("hidden", !this.isPlaying);
    this.toggleBtn?.setAttribute("aria-label", this.isPlaying ? "Pause banner" : "Play banner");
  }

  scheduleNext() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.advance(), this.interval);
  }

  advance() {
    this.activeIndex++;
    const fromY = -((this.activeIndex - 1) * this.messageHeight);
    const toY = -(this.activeIndex * this.messageHeight);

    const anim = animate(
      this.track,
      { y: [`${fromY}px`, `${toY}px`] },
      { duration: TRANSITION_DURATION, easing: TRANSITION_EASING }
    );

    anim.finished.then(() => {
      if (this.activeIndex >= this.messages.length) {
        this.track.style.transform = "translateY(0)";
        this.activeIndex = 0;
      }
      this._updateInert();
      if (this.isPlaying) this.scheduleNext();
    });
  }

  _updateInert() {
    this.messages.forEach((msg, i) => {
      msg.toggleAttribute("inert", i !== this.activeIndex);
    });
  }
}

if (!customElements.get("message-ticker")) {
  customElements.define("message-ticker", MessageTicker);
}
